/* RULY HAIRSTYLIST — booking.js
   Generates appointment slots from opening hours held in theme settings.
   Times ride along to checkout as line item properties, so they appear on
   the order. This does NOT reserve time on a real calendar — see README. */
(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  // Parse "YYYY-MM-DD" in LOCAL time. new Date(str) would read it as UTC
  // and shift the weekday for anyone west of Greenwich.
  function localDate(str) {
    var p = String(str).split('-');
    return new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
  }
  function toISO(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function toMinutes(hhmm) {
    var p = String(hhmm).split(':');
    return parseInt(p[0], 10) * 60 + parseInt(p[1] || '0', 10);
  }
  function label(mins, use24) {
    var h = Math.floor(mins / 60), m = mins % 60;
    if (use24) return pad(h) + ':' + pad(m);
    var ap = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12 === 0 ? 12 : h % 12;
    return h12 + ':' + pad(m) + ' ' + ap;
  }

  document.querySelectorAll('[data-booking]').forEach(function (form) {
    var dateInput = form.querySelector('[data-book-date]');
    var timeInput = form.querySelector('[data-book-time]');
    var slotBox   = form.querySelector('[data-slots]');
    if (!dateInput || !timeInput || !slotBox) return;

    var hours    = JSON.parse(form.getAttribute('data-hours') || '{}');
    var interval = parseInt(form.getAttribute('data-interval') || '30', 10);
    var duration = parseInt(form.getAttribute('data-duration') || '60', 10);
    var lead     = parseInt(form.getAttribute('data-lead') || '2', 10);      // hours of notice
    var horizon  = parseInt(form.getAttribute('data-horizon') || '60', 10);  // days ahead
    var use24    = form.getAttribute('data-clock') === '24';
    var closed   = (form.getAttribute('data-closed-dates') || '')
      .split(',').map(function (s) { return s.trim(); }).filter(Boolean);

    var msgClosed = form.getAttribute('data-msg-closed') || 'Cerrado ese día. Elige otra fecha.';
    var msgFull   = form.getAttribute('data-msg-full') || 'No quedan horarios ese día.';
    var msgPick   = form.getAttribute('data-msg-pick') || 'Elige una fecha para ver los horarios.';

    // Bound the date field to the booking window.
    var today = new Date();
    var min = new Date(today); min.setDate(min.getDate());
    var max = new Date(today); max.setDate(max.getDate() + horizon);
    dateInput.min = toISO(min);
    dateInput.max = toISO(max);

    function note(text) {
      slotBox.innerHTML = '';
      var p = document.createElement('p');
      p.className = 'slots__empty';
      p.textContent = text;
      slotBox.appendChild(p);
      timeInput.value = '';
    }

    function build() {
      timeInput.value = '';
      var val = dateInput.value;
      if (!val) { note(msgPick); return; }

      if (closed.indexOf(val) !== -1) { note(msgClosed); return; }

      var d = localDate(val);
      var day = String(d.getDay());
      var window_ = hours[day];
      if (!window_ || !window_.length) { note(msgClosed); return; }

      var open  = toMinutes(window_[0]);
      var close = toMinutes(window_[1]);

      // Earliest bookable minute today, respecting lead time.
      var now = new Date();
      var isToday = toISO(now) === val;
      var earliest = isToday ? (now.getHours() * 60 + now.getMinutes() + lead * 60) : -1;

      var frag = document.createDocumentFragment();
      var count = 0;

      for (var t = open; t + duration <= close; t += interval) {
        if (t < earliest) continue;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'slot';
        b.setAttribute('aria-pressed', 'false');
        b.setAttribute('data-value', label(t, use24));
        b.textContent = label(t, use24);
        frag.appendChild(b);
        count++;
      }

      if (!count) { note(msgFull); return; }
      slotBox.innerHTML = '';
      slotBox.appendChild(frag);
    }

    slotBox.addEventListener('click', function (e) {
      var b = e.target.closest('.slot');
      if (!b) return;
      slotBox.querySelectorAll('.slot').forEach(function (o) {
        o.setAttribute('aria-pressed', String(o === b));
      });
      timeInput.value = b.getAttribute('data-value');
      var err = form.querySelector('[data-form-error]');
      if (err) err.textContent = '';
    });

    dateInput.addEventListener('change', build);
    build();
  });
})();
